var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-badge',{staticClass:"remove-minute-event-icon text-danger",attrs:{"pill":"","variant":"light"},on:{"click":function($event){return _vm.remove(_vm.event, true)}}},[_c('font-awesome-icon',{attrs:{"icon":"times","size":"1x"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }